import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

export default class extends Controller {
  static targets = ["dateInput", "timeInput", "notesContainer", "noteTemplate", "materialsContainer", "materialTemplate"]

  connect() {
    this.flatpickrInstances = []
    if (this.hasNotesContainerTarget) {
      this.nextNoteIndex = this.notesContainerTarget.querySelectorAll("[data-note-row]").length
    }
    if (this.hasMaterialsContainerTarget) {
      this.nextMaterialIndex = this.materialsContainerTarget.querySelectorAll("[data-material-row]").length
    }
    this.initFlatpickr()
  }

  disconnect() {
    this.flatpickrInstances?.forEach((instance) => instance.destroy())
    this.flatpickrInstances = []
  }

  initFlatpickr() {
    this.dateInputTargets.forEach((input) => {
      if (input.dataset.flatpickrInitialized === "true") return

      const appendTo = input.closest("dialog") || document.body
      this.flatpickrInstances.push(flatpickr(input, {
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "m-d-Y",
        altInputClass: "input input-bordered w-full",
        allowInput: true,
        disableMobile: true,
        appendTo
      }))
      input.dataset.flatpickrInitialized = "true"
    })

    this.timeInputTargets.forEach((input) => {
      if (input.dataset.flatpickrInitialized === "true") return

      const appendTo = input.closest("dialog") || document.body
      this.flatpickrInstances.push(flatpickr(input, {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        altInput: true,
        altFormat: "h:i K",
        altInputClass: "input input-bordered w-full",
        time_24hr: false,
        allowInput: true,
        disableMobile: true,
        appendTo
      }))
      input.dataset.flatpickrInitialized = "true"
    })
  }

  addMaterialRow(event) {
    event.preventDefault()
    if (!this.hasMaterialsContainerTarget || !this.hasMaterialTemplateTarget) return

    const index = this.nextMaterialIndex
    const html = this.materialTemplateTarget.innerHTML.replace(/NEW_RECORD/g, index)
    this.materialsContainerTarget.insertAdjacentHTML("beforeend", html)
    this.nextMaterialIndex += 1
  }

  removeMaterialRow(event) {
    event.preventDefault()
    const row = event.target.closest("[data-material-row]")
    if (!row) return

    const destroyField = row.querySelector("[data-destroy-field]")
    if (destroyField) {
      destroyField.value = "1"
      row.classList.add("hidden")
      return
    }

    row.remove()
  }

  addNoteRow(event) {
    event.preventDefault()
    if (!this.hasNotesContainerTarget || !this.hasNoteTemplateTarget) return

    const index = this.nextNoteIndex
    const html = this.noteTemplateTarget.innerHTML.replace(/NEW_NOTE/g, index)
    this.notesContainerTarget.insertAdjacentHTML("beforeend", html)
    this.nextNoteIndex += 1
  }

  removeNoteRow(event) {
    event.preventDefault()
    const row = event.target.closest("[data-note-row]")
    if (!row) return

    const destroyField = row.querySelector("[data-destroy-field]")
    if (destroyField) {
      destroyField.value = "1"
      row.classList.add("hidden")
      return
    }

    row.remove()
  }

  removeDocumentRow(event) {
    event.preventDefault()
    const row = event.target.closest("[data-document-row]")
    if (!row) return

    const removeField = row.querySelector("[data-remove-document-id]")
    if (removeField) {
      removeField.disabled = false
    }

    row.classList.add("hidden")
  }
}
